import React from 'react';
import Markdown from 'react-markdown';

/**
 * MarkDown Text Component
 * @param {children} - Text Children
 * @returns
 */
function MText({ children, className }) {
  return <Markdown className={className ?? ''}>{children}</Markdown>;
}

export default MText;
